import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-privacy-public',
  templateUrl: './icon-privacy-public.component.html',
  styleUrls: ['./icon-privacy-public.component.scss']
})
export class IconPrivacyPublicComponent implements OnInit {
  @Input() color = '#D0D0D0';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
